<div tabindex="0" class="text-block-container" [ngClass]="{ 'error-highlight': showTextLimitWarning }">
  <div #editor class="text-block-content" (keyup)="checkTextSize()" data-test="quill-editor"></div>
</div>
